import * as charts from "../../charts/";
import { ChartType } from "../../entities/reportEntity";

export default {
  id: 103,
  label: "IPC申请人分析",
  chart: charts.lineAndBar2D,
  definition: {
    rowDims: [{ name: "ipcName", label: "IPC分类", limit: 10, table: "patent_ipc", needTotal: true }],
    colDims: [
      {
        name: "applicantNewName",
        label: "申请人",
        table: "patent_applicant",
        limit: 10,
        needTotal: true,
      },
    ],
    measures: [{ name: "count", label: "专利量", sortBy: "DESC" }],
    showNoDataDims: true,
  },
  chartOption: {
    chartType: ChartType.BAR,
    title: "IPC申请人分析",
    subTitle: "",
    hideTitle: false,
    xaxisTitle: "",
    yaxisTitle: "",
    hideAxisTitle: true,
    hideLabel: true,
    hideLegend: false,
    hideToolbox: false,
  },
};
